module.exports = "## Dialog\n\n[Dialogs](https://www.google.com/design/spec/components/dialogs.html) contain text\nand UI controls focused on a specific task. They inform users about critical information,\nrequire users to make decisions, or involve multiple tasks.\n\nDialog can only be a controlled component.\nYou must provide the open prop and handle `onRequestClose` in order to use this component.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Dialog/README.md
 ** module id = 969
 ** module chunks = 0
 **/